import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { QuickshghtService } from 'src/app/shared/services/quickshght.service';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-quicksight',
    templateUrl: './quicksight.component.html',
    styleUrls: ['./quicksight.component.scss'],
    standalone: false
})
export class QuicksightComponent implements OnInit, AfterViewInit {
@ViewChild('embeddingContainer', { static: true })
  embeddingContainer!: ElementRef<HTMLDivElement>;

  url: any;

  reportInstancedata: any = [];
  convertObjects: any;
  convertFilters: any;

  finalJson = {
    instanceid: "",
    instancedetailid: "",
    templatename: "",
    reportname: "",
    qsreportreference: "",
    scheduleddatetime: "",
    vaultuploadstatus: "",
    reportpath: "",
    analysisreference: "",
    filters: []
  };

  anaylsis: any;

  // keep reference if you want to apply filters later
  private dashboardExperience: any;
  private embeddingContext: any;

  constructor(
    private quickSightService: QuickshghtService,
    private spinner: NgxUiLoaderService,
    private route: ActivatedRoute,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(v => {
      this.spinner.start();
      this.anaylsis = v.anaylsis;
      this.reportInstancedata = v.data;
      this.spinner.stop();

      // We'll embed after view init (container exists). Just load URL now.
      if (this.anaylsis !== undefined) {
        this.retrieveAnalysis(this.anaylsis);
      } else {
        this.retrieveEmbededurl();
      }
    });
  }

 async ngAfterViewInit() {
   }

  private async embedQuickSight(embedUrl: string) {
    // const container = document.getElementById("embeddingContainer");
    // if (!container) {
    //   console.error("embeddingContainer not found in DOM");
    //   return;
    // }

    // create once
    if (!this.embeddingContext) {
      this.embeddingContext = await createEmbeddingContext();
    }
    
     try {
       this.spinner.start();
 
 
       if (!embedUrl) {
         throw new Error('Embed URL missing from backend response');
       }
 
       const embeddingContext = await createEmbeddingContext();
 
       // SDK v2.x: embedDashboard is a method on embeddingContext
       this.dashboardExperience = await embeddingContext.embedConsole(
         {
           url: embedUrl,
           container: this.embeddingContainer.nativeElement,
           height: '88vh',
           width: '100%',
         }
       );
 
       // Events in v2 are typically via "on" on the experience
       this.dashboardExperience.on?.('load', () => console.log('QuickSight dashboard loaded'));
       this.dashboardExperience.on?.('error', (e: any) => console.error('QuickSight dashboard error', e));
 
     } catch (e) {
       console.error('QuickSight embed failed:', e);
     } finally {
       this.spinner.stop();
     }
  }

  retrieveAnalysisbyid(e: any) {
    console.log(e);
    debugger
    
    this.quickSightService.retrieveanalysis(e).subscribe(res => {
      console.log(res);
    });
  }

  retrieveAnalysis(e: any) {
    this.spinner.start();

    this.quickSightService.getAnalysis(e).subscribe({
      next: async (res) => {
        this.url = res;
        await this.embedQuickSight(this.url.embededUrl);
        this.spinner.stop();
      },
      error: (err) => {
        console.error(err);
        this.spinner.stop();
      }
    });
  }

  retrieveEmbededurl() {
    this.spinner.start();

    this.quickSightService.geturl().subscribe({
      next: async (res) => {
        this.url = res;
        await this.embedQuickSight(this.url.embededUrl);
        this.spinner.stop();
      },
      error: (err) => {
        console.error(err);
        this.spinner.stop();
      }
    });
  }

  savedata() {
    this.convertObjects = JSON.parse(this.reportInstancedata);
    this.finalJson.instanceid = this.convertObjects.instanceid;
    this.finalJson.instancedetailid = this.convertObjects.instancedetailid;
    this.finalJson.templatename = this.convertObjects.templatename;
    this.finalJson.reportname = this.convertObjects.reportname;
    this.finalJson.qsreportreference = this.convertObjects.qsreportreference;
    this.finalJson.scheduleddatetime = this.convertObjects.scheduleddatetime;
    this.finalJson.vaultuploadstatus = this.convertObjects.vaultuploadstatus;
    this.finalJson.reportpath = this.convertObjects.reportpath;
    this.finalJson.analysisreference = this.convertObjects.analysisreference;
    this.finalJson.filters = JSON.parse(this.convertObjects.filters);

    this.quickSightService.converToPdf(this.finalJson).subscribe(response => {
      this.spinner.start();
      this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
      this.spinner.stop();
    });
  }
}
